export const FORGOT_USERNAME_HEADER = "forgot-username-header";
export const GET_USERNAME = "forgot-username-get-username";
export const FORGOT_USERNAME_CONTENT_1 = "forgot-username-content-1";
export const FORGOT_USERNAME_CONTENT_2 = "forgot-username-content-2";
export const FORGOT_USERNAME_FORM = "forgot-user-name-form";
export const FORGOT_USERNAME_BACK_BUTTON = "forgot-username-back-button";
export const MATCH_NOT_FOUND = "MATCH_NOT_FOUND";
export const USERNAME_SENT_SUCCESSFULLY = "USERNAME_SENT_SUCCESSFULLY";

export const EMAIL_SENT_HEADER = "forgot-username-email-sent-header";
export const EMAIL_SENT_CONTENT_1 = "forgot-username-email-sent-content-1";
export const EMAIL_SENT_CONTENT_2 = "forgot-username-email-sent-content-2";
export const EMAIL_SENT_CONTENT_3 = "forgot-username-email-sent-content-3";
export const EMAIL_SENT_CONTENT_4 = "forgot-username-email-sent-content-4";
export const EMAIL_SENT_ALERT_HEADER =
  "forgot-username-email-sent-alert-header";
export const EMAIL_SENT_ALERT_CONTENT_1 =
  "forgot-username-email-sent-alert-content1";
export const GO_TO_LOGIN = "forgot-username-go-to-login";
